import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@rebass/grid';
// components
import CriteriaCounts from 'app/ui_components/CriteriaCounts';
import Improvements from 'app/components/Improvements';
// helpers
import { isMobile } from 'app/helpers/utils';

export default class ResultsActionsColumn extends React.Component {
  static defaultProps = {
    id: 'ResultsActionsColumn',
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    shouldFixSidebar: PropTypes.bool.isRequired,
    upperBound: PropTypes.number.isRequired,
  };

  state = {
    shouldScroll: false,
  };

  componentDidMount() {
    // If the bottom of the container is below the bottom of the viewport,
    // shrink the container. We wait 2 seconds to allow the position update
    // within render() to occur.
    setTimeout(this.potentiallyResize, 2000);
  }

  potentiallyResize = () => {
    const { top, height } = document
      .getElementById(this.props.id)
      .getBoundingClientRect();
    if (top + height > window.innerHeight) {
      this.setState({ shouldScroll: true });
    }
  };

  render() {
    const {
      props: { upperBound, shouldFixSidebar, id },
      state: { shouldScroll },
    } = this;

    return (
      <Box
        id={id}
        width={[1 / 1, 1 / 1, 1 / 4]}
        style={{
          position: shouldFixSidebar && !isMobile ? 'fixed' : 'relative',
          top: shouldFixSidebar ? upperBound : 'unset',
          bottom: shouldScroll ? 0 : null,
          overflowY: shouldScroll ? 'scroll' : null,
        }}
      >
        <CriteriaCounts />
        <Improvements />
      </Box>
    );
  }
}
